<template>
  <div class="threejsContainer">
    <div class="containerTitle">1-8.原始几何体</div>
    <div ref="container" class="containerBody"></div>
  </div>
</template>

<script>
import {generateScene} from '@/threejsEnv/scene.js';
import {genPerspectiveCamera} from '@/threejsEnv/camera.js';
import {genRenderer} from '@/threejsEnv/renderer.js';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
import {genPlaneGeometry,genCircleGeometry,
        genBoxGeometry,genCapsuleGeometry,genConeGeometry,genCylinderGeometry,genDodecahedronGeometry,
        genSphereGeometry,genTubeGeometry,
        genEdgesGeometry} from './components/SrGeometry';

export default {
  data(){
    return {
      scene:null,
      camera:null, 
      renderer:null, 
      u_time:0,
      control: null,
      animationId: null, // 新增这一行
      window:{
        width: 0,
        height: 0
      }
    }
  },
  mounted(){
    this.window.width = window.innerWidth;
    this.window.height = window.innerHeight;

    this.scene = generateScene();
    
    this.camera = genPerspectiveCamera(this.window);

    this.renderer = genRenderer(this.window)

    this.control  = new OrbitControls(this.camera, this.renderer.domElement); 
    this.control.enableDamping = true; 
    this.control.dampingFactor = 0.05;

    this.$refs.container.appendChild(this.renderer.domElement);

    this.initPanel();
    this.render();
    //添加监听
    window.addEventListener('resize', this.onWindowResize);
  },
  methods:{
    initPanel(){
      
      this.scene.add(genPlaneGeometry());
      this.scene.add(genCircleGeometry());
      
      this.scene.add(genConeGeometry());
      this.scene.add(genBoxGeometry());
      this.scene.add(genCapsuleGeometry());
      this.scene.add(genCylinderGeometry());
      this.scene.add(genDodecahedronGeometry());
      this.scene.add(genSphereGeometry());
      this.scene.add(genTubeGeometry());
      
      genEdgesGeometry(this.scene);
      
    },
    render() {
      this.animationId = requestAnimationFrame(this.render); 
      this.renderer.render(this.scene, this.camera);
      this.control.update();
    },
    onWindowResize(){
        const container = this.$refs.container;
        const width = container.clientWidth;
        const height = container.clientHeight;

        // 1. 更新相机的宽高比 (aspect)
        this.camera.aspect = width / height;
        // 【关键】更新相机的投影矩阵，使更改生效
        this.camera.updateProjectionMatrix();

        // 2. 更新渲染器的尺寸
        this.renderer.setSize(width, height);
    }
  },
  beforeDestroy(){
    cancelAnimationFrame(this.animationId);
    this.renderer.domElement.remove(); // 从 DOM 中移除 canvas 元素
    this.renderer.dispose(); // 释放渲染器内存
  },
  destroyed(){
    this.scene = null;
    this.camera = null;
    this.renderer = null;
  }
}
</script>

<style scoped>

</style>